import React, { FC, memo, useState } from "react";
import { Rating, RatingProps } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { calculateStarColor } from "../../util/scoringUtils";
import { useTheme,Theme } from '@mui/material/styles';

type IScoringRatingProps = {
    index?: number;
    onChange?: (index: number, value: number) => void;
} & RatingProps;

const ScoringRating: FC<IScoringRatingProps> = (props) => {
    const { value, onChange, index, ...other } = props;
    const [currentHoveredValue, setCurrentHoveredValue] = useState<number>(-1);
    const colorIndex = currentHoveredValue === -1 ? value : currentHoveredValue;
    const ratingColor = calculateStarColor(colorIndex);
    const theme = useTheme();
    return (
        <Rating
            className="ScoringRating"
            sx={{
                ".MuiRating-iconHover svg": {
                    color: `${ratingColor} !important`,
                },
                ".MuiRating-iconFilled svg": {
                    color: `${ratingColor} !important`,
                },
            }}
            value={value}
            emptyIcon={
                <StarIcon
                    sx={{ color: theme?.custom?.disabledColor, fontSize: "inherit" }}
                />
            }
            onChangeActive={(event, value) => setCurrentHoveredValue(value)}
            onChange={(event, value) => {
                onChange(index, value || 0);
            }}
            {...other}
        />
    );
};

export default memo(ScoringRating);
